import React from 'react';

export default class IframeLandingPage extends React.Component {
    render() {
        return <iframe
            style={{
                width: '100%',
                height: '100%'
            }}
            src={this.props.link}
            frameBorder="0"
        />
    }
}
